module.exports = __webpack_public_path__ + "img/parter-avatar3.7df5bb69.png";